export default __webpack_public_path__ + "static/media/valley14.ab47ec2d.png";